var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{staticClass:"whirelab-input black--text text-body-2",staticStyle:{"padding-left":"20px"},attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"required":_vm.required,"rules":_vm.rules,"rounded":""},on:{"keyup":function($event){return _vm.updateValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }